<div class="login" *ngIf="!loading">
    <div class="animated fadeInRight" *ngIf="!loading">
        <div class="app-body">
            <main class="main d-flex align-items-center">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-10 col-md-8 mx-auto">
                            <div class="card-group border border-warning">
                                <div class="card text-black-50 bg-light border-warning py-5 d-md-down-none"
                                    style="width:100%">
                                    <div class="card-body text-center">
                                        <div>
                                            <object>
                                                <embed src="../../../../../assets/images/logo/lafabril-logo-medium.svg">
                                            </object>
                                        </div>
                                    </div>
                                </div>
                                <div class="card border-warning p-4">
                                    <div class="card-body">
                                        <form [formGroup]="formulario" novalidate class="form-group">
                                            <h3 class="card-title">Iniciar Sesión</h3>
                                            <div class="input-group mb-4 mt-4">
                                                <!-- <div class="input-group-prepend"> -->
                                                <span class="input-group-text"> <i class="fa fa-user"
                                                        aria-hidden="true"></i> </span>
                                                <!-- </div> -->
                                                <input class="form-control" type="text" placeholder="Usuario"
                                                    formControlName="username">
                                            </div>
                                            <div class="input-group mb-4">
                                                <!-- <div class="input-group-prepend"> -->
                                                <span class="input-group-text"> <i class="fa fa-key"
                                                        aria-hidden="true"></i> </span>
                                                <!-- </div> -->
                                                <input class="form-control" (keydown.enter)="onLogin()" type="password"
                                                    placeholder="Contraseña" formControlName="password">
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <button type="button" class="btn btn-outline-warning px-4 ngcl"
                                                        (click)="onLogin()"
                                                        [disabled]="formulario.invalid">Login</button>
                                                </div>
                                            </div>
                                            <br>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <a routerLink="/recuperar-clave"
                                                        routerLinkActive="active">Recuperación Clave</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</div>

<!-- <div  class="containerLoader" *ngIf="loading">
    <h1>
        <em>K</em>
        <em class="planet left">O</em>
        <em>S</em>
        <em>M</em>
        <em class="planet right">O</em>
        <em>S</em>
      </h1>
</div> -->
<div class="containerLoader" *ngIf="loading">
    <div class="item-1"></div>
    <div class="item-2"></div>
    <div class="item-3"></div>
    <div class="item-4"></div>
    <div class="item-5"></div>
</div>